import { FaPhoneAlt } from "react-icons/fa";
import { IoMail } from "react-icons/io5";
import ContactForm from "../forms/contactForm";
import CtaOffer from "../common/ctaOffer";

function Offer3TrawaSiew() {
  return (
    <>
      {/* HERO */}
      <section className="relative overflow-x-hidden flex flex-col lg:flex-row items-center justify-between lg:min-h-[60vh] p-6 lg:px-12 lg:pt-48 lg:pb-36 gap-6">
        <img
          className="absolute w-full h-full object-cover z-10 top-0 left-0"
          src="https://magazyn.drzewus.pl/wp-content/uploads/2025/03/trawa-z-siewu-Large.jpeg"
          alt="Trawnik z siewu - zakładanie trawy z nasion - Drzewus"
        />
        <div className="w-full h-full object-cover z-20 absolute top-0 left-0 gradient-green-ltr"></div>
        <div className="flex flex-col items-start justify-center gap-2 z-30">
          <h1 className="text-3xl lg:text-6xl text-white text-left">
            Zakładanie trawników z siewu Gdańsk, Gdynia, Wejherowo, Kaszuby
          </h1>
          <h2 className="text-xl lg:text-3xl text-white text-left">
            Trwały i gęsty trawnik dopasowany do gleby na Twojej działce
          </h2>
          <p className="text-white text-base lg:text-xl max-w-[850px] text-left">
            Profesjonalne zakładanie trawnika metodą siewu to sprawdzony sposób na piękną zieleń wokół domu na terenie Gdańska, Gdyni, Kartuz i Kaszub. Starannie dobieramy mieszanki traw do rodzaju gruntu i stopnia zacienienia posesji. Cały proces poprzedzamy dokładnym oczyszczeniem gruntu, spulchnieniem ziemi oraz <a href="/oczyszczanie-terenu/niewelacja-terenu" className="underline hover:opacity-80">niwelacją terenu</a>.
          </p>
          <a href="#wiecej">
            <button className="button-yellow">Dowiedz się więcej</button>
          </a>
        </div>
        <div className="z-30 max-w-[500px] flex flex-col items-center justify-center">
          {" "}
          <ContactForm />
        </div>
      </section>
      {/* CONTENT */}
      <section
        id="wiecej"
        className="p-6 lg:px-24 lg:py-12 grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-12"
      >
        <div className="lg:col-span-1 flex flex-col gap-6">
          <div className="flex flex-col gap-2 p-6 rounded-xl bg-green w-full">
            <a
              href="#1"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Zakładanie trawnika
            </a>
            <a
              href="#2"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Dlaczego warto powierzyć zakładanie trawnika właśnie nam?
            </a>
          </div>
          <CtaOffer />
        </div>
        <div className="lg:col-span-2 flex flex-col items-start justify-start text-left gap-2 content-offer">
          <h2 id="1">Zakładanie trawnika</h2>
          <p>
            Wypielęgnowana murawa otaczająca budynek prezentuje się pięknie.
            Równo przycięty zielony trawnik sprawia, że teren wydaje się
            idealnie uporządkowany. Wykonanie takiego trawnika jest czasochłonne
            i pracochłonne. Trzeba wykonać projekt, przygotować glebę oraz
            dobrać odpowiednie gatunki traw i je zasiać. Wymaga to wiele pracy,
            dlatego zakładanie trawnika warto powierzyć fachowcom, którzy
            wykonali już kilkaset metrów trawników.
          </p>

          <p>W ramach usługi zakładania trawnika:</p>
          <ul>
            <li>
              zaprojektujemy trawnik, tak aby długo prezentował się idealnie;
            </li>
            <li>
              dobieramy nasiona trawy do gleby oraz indywidualnych potrzeb
              klienta;
            </li>
            <li>
              przygotowujemy podłoże pod trawę:
              <ul>
                <li>
                  wykonujemy prace porządkowe - oczyszczamy teren z kamieni,
                  śmieci, gruzu, liści oraz chwastów;
                </li>
                <li>
                  na życzenie klienta układamy instalację nawadniającą przed
                  wykonaniem trawnika;
                </li>
                <li>
                  przy pomocy glebogryzarki ziemia zostaje odpowiednio
                  napowietrzona i spulchniona, co sprzyja wzrostowi trawy;
                </li>
                <li>
                  ulepszamy jakość gleby - sprawdzamy jej pH, zakwaszamy lub
                  odkwaszamy w zależności od potrzeb;
                </li>
                <li>
                  niwelujemy (wyrównujemy powierzchnię gleby) za pomocą ciągnika
                  John Deere;
                </li>
                <li>
                  zabezpieczamy trawnik przed kretami, rozkładając siatkę na
                  właściwej głębokości;
                </li>
                <li>
                  wykańczamy brzegi trawnika zgodnie z życzeniami klienta, np.
                  ekobordem, palisadami, kostką granitową, co ułatwia późniejszą
                  pielęgnację.
                </li>
              </ul>
            </li>
            <li>
              doradzamy w samodzielnym nawożeniu trawnika - dobieramy właściwy
              nawóz i podpowiadamy, jak go stosować;
            </li>
            <li>
              wysiewamy trawę - na końcowy efekt trzeba poczekać około miesiąca;
            </li>
            <li>wałujemy i nawadniamy;</li>
            <li>
              udzielamy wskazówek, jak pielęgnować przydomowy trawnik, w tym
              pierwsze koszenie, podlewanie i nawożenie.
            </li>
          </ul>

          <h2 id="2">
            Dlaczego warto powierzyć zakładanie trawnika właśnie nam?
          </h2>
          <p>
            W naszej pracy łączymy pasję, wiedzę i doświadczenie w projektowaniu
            oraz zakładaniu ogrodów. Dzięki temu wszystkie nasze prace
            wykonywane są z najwyższą starannością przy użyciu nowoczesnego
            sprzętu, m.in. ciągnika John Deere. Nasze usługi realizujemy zgodnie
            z życzeniem klienta.
          </p>

          <p>Kiedy powierzysz nam założenie swojego trawnika:</p>
          <ul>
            <li>
              możesz być pewien, że nasze usługi są wykonywane przez ekspertów
              ogrodnictwa, co gwarantuje trwały efekt;
            </li>
            <li>otrzymujesz kompleksową usługę - od projektu po realizację;</li>
            <li>dzięki kompleksowej usłudze zaoszczędzisz czas i pieniądze;</li>
            <li>
              zakładanie trawnika przez naszą firmę jest zazwyczaj tańsze i
              mniej pracochłonne niż samodzielne wykonanie;
            </li>
            <li>
              doradzamy w wyborze nasion trawy odpowiednich dla danego terenu:
            </li>
            <ul>
              <li>rozmawiamy o potrzebach klienta,</li>
              <li>proponujemy najlepsze rozwiązanie,</li>
              <li>omawiamy zakres wykonywanych prac.</li>
            </ul>
            <li>Twój trawnik zostanie fachowo założony.</li>
          </ul>

          <p>
            Nie czekaj. Zadzwoń do nas już dziś, aby zarezerwować termin
            zakładania przydomowego trawnika!
          </p>
        </div>
      </section>
      {/* PORTFOLIO */}
      <section className="p-6 lg:px-24 lg:py-12 flex flex-col gap-6">
        <div className="flex flex-col lg:flex-row items-start justify-start lg:items-center lg:justify-between gap-6 lg:gap-24">
          <div className="flex flex-col items-start justify-start gap-2 w-full">
            {" "}
            <h2 className="uppercase color-yellow text-xl">Nasze realizacje</h2>
            <h3 className="text-3xl lg:text-5xl color-green text-left">
              Spójrz jak pomogliśmy<br></br>
              <span className="color-yellow">naszym Klientom</span>
            </h3>
          </div>
          <div className="flex flex-col items-start justify-center w-full lg:w-2/3">
            <p className="text-gray-600 text-left">
              Przekonaj się, jak wyglądają efekty naszych prac przy zakładaniu trawników z siewu oraz kompleksowym przygotowaniu podłoża. Od lat dbamy o każdy detal zielonej murawy.
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/07/trawa-z-siewu-1.jpeg"
              alt="Trawnik z siewu - realizacja Drzewus nr 1"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/02/Realizacja-2.jpg"
              alt="Trawnik z siewu - realizacja Drzewus nr 2"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/07/trawa-z-siewu-2.jpeg"
              alt="Trawnik z siewu - realizacja Drzewus nr 3"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/realizacja-4.jpg"
              alt="Trawnik z siewu - realizacja Drzewus nr 4"
              className="h-full object-cover w-full"
            />
          </div>
        </div>
      </section>
      {/* <section className="p-6 lg:px-24 lg:py-12 flex flex-col gap-6">
        <div className="flex flex-col items-center justify-center mb-6">
          <h2 className="uppercase color-yellow text-xl text-center">
            Nasze realizacje
          </h2>
          <h3 className="text-3xl lg:text-5xl color-green text-center">
            Spójrz jak pomogliśmy<br></br>
            <span className="color-yellow">naszym Klientom</span>
          </h3>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/home-portfolio-1.png"
              alt="Portfolio ogrodu Drzewus nr 1"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/home-portfolio-2.png"
              alt="Portfolio ogrodu Drzewus nr 2"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-1">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/home-portfolio-3.png"
              alt="Portfolio ogrodu Drzewus nr 3"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/home-portfolio-4.png"
              alt="Portfolio ogrodu Drzewus nr 4"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-1">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/home-portfolio-5.png"
              alt="Portfolio ogrodu Drzewus nr 5"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/home-portfolio-6.png"
              alt="Portfolio ogrodu Drzewus nr 6"
              className="h-full object-cover w-full"
            />
          </div>
        </div>
      </section> */}
    </>
  );
}

export default Offer3TrawaSiew;
